export default class ClienteIKAcesso {
    constructor() {
        this.id =  null;
        this.nome =  null;
        this.email = null;
        this.razaoSocial =  null;
        this.cpf =  null;
        this.cnpj =  null;
        this.telefone =  null;
        this.celular =  null;
        this.estado =  null;
        this.cidade =  null;
        this.endereco =  null;
        this.dataCadastro =  null;
        this.ativo =  null;	
        this.licencas =  [];
    }
}